'use client'
import React, { useState } from 'react'
import SearchComponent from '../../../components/base/SearchComponent'
import styles from '../page.module.scss'
import TopCategory from './TopCategory'
import TextMorphAnimation from '../../../components/TextMorphAnimation'

const HeroHeading = () => {
	return (
		<>
			<TextMorphAnimation />
			<span className={styles.bottomTitle}>Building Stronger & Sustainable Metal Supply Chain</span>
		</>
	)
}

const BannerTwo = ({ categoryData }) => {
	const [showSearch, setShowSearch] = useState(false)
	return (
		<>
			<div className={`d-flex ${styles.banner}`}>
				<div className={styles.textContainer}>
					<HeroHeading />
					<SearchComponent showSearch={showSearch} setShowSearch={setShowSearch} categoryData={categoryData} />
					<TopCategory categoryData={categoryData} />
				</div>
			</div>
			<div className={`${styles.closeSearchList}  ${showSearch ? 'd-block' : 'd-none'}`} onClick={() => setShowSearch(false)}></div>
		</>
	)
}

export default BannerTwo
